export default __webpack_public_path__ + "static/media/arrow_back.6b5c17c6.svg";